import { __decorate } from "tslib";
import { provideAuthStrategy, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { ForceNewPasswordComponent } from './force-new-password';
import { LoginFormComponent } from './login-form/login-form.component';
import * as i0 from "@angular/core";
let AuthStrategyCredentialsFrontendFeature = /*#__PURE__*/(() => {
  let AuthStrategyCredentialsFrontendFeature = class AuthStrategyCredentialsFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/auth-strategy-credentials/frontend","featureId":"common-auth-strategy-credentials"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: ForceNewPasswordComponent
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵAuthStrategyCredentialsFrontendFeature_BaseFactory;
        return function AuthStrategyCredentialsFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵAuthStrategyCredentialsFrontendFeature_BaseFactory || (ɵAuthStrategyCredentialsFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(AuthStrategyCredentialsFrontendFeature)))(__ngFactoryType__ || AuthStrategyCredentialsFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: AuthStrategyCredentialsFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'auth/credentials',
          loadChildren: () => import('./auth-strategy-credentials-frontend.module').then(m => m.AuthStrategyCredentialsFrontendModule)
        }]), provideAuthStrategy({
          name: 'credentials',
          authenticate: {
            entrypoint: LoginFormComponent
          }
        })
        // provideFeatureAddonRoutes([])
        ]
      });
    }
  };
  AuthStrategyCredentialsFrontendFeature = __decorate([ClassName("AuthStrategyCredentialsFrontendFeature")], AuthStrategyCredentialsFrontendFeature);
  return AuthStrategyCredentialsFrontendFeature;
})();
export { AuthStrategyCredentialsFrontendFeature };